export var GOOGLE_UNIVERSAL_ANALYTICS_NAME = 'GOOGLE_UA';
export var GOOGLE_ANALYTICS_4_NAME = 'GOOGLE_GA4';
export var FISHERMAN_EVENT = 'fisherman_event';
export var AnalyticsAction = Object.freeze({
  CLICK: 'click',
  NO_INTERACTION: 'no_interaction'
});